/**
 * @description Convert array to a lookup object by a key
 *
 */
Array.prototype.groupBy = function(key) {
  const isKeyFunc = typeof key === "function";
  return this.reduce(function(groups, item) {
    const val = isKeyFunc ? key(item) : item[key];
    groups[val] = groups[val] || [];
    groups[val].push(item);
    return groups;
  }, {});
};

String.prototype.splitByIndex = function(index) {
  const result = [this.slice(0, index), this.slice(index, this.length)];
  return result;
};

String.prototype.isValidEmailAddress = function() {
  // taken from https://stackoverflow.com/a/46181/3148807
  const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(this);
};



// WEBPACK FOOTER //
// ./src/helpers/extentions.js